import { MenuItem, useDisclosure } from "@chakra-ui/react";

import { CloseMarginCallOrAlertModal } from "./Modal";

interface CloseCallMenuButtonProps {
  account: string;
  eventId: string;
  isCall?: boolean;
  onSuccess?: () => void;
}

const CloseCallOrAlertMenuItem = ({
  account,
  eventId,
  isCall,
  onSuccess,
}: CloseCallMenuButtonProps) => {
  const {
    onClose: onCloseCallClose,
    isOpen: isCloseCallOpen,
    onOpen: onCloseCallOpen,
  } = useDisclosure();

  return (
    <>
      <MenuItem
        data-testid="open-close-call-modal"
        onClick={e => {
          e.stopPropagation();
          onCloseCallOpen();
        }}
      >
        Close
      </MenuItem>
      <CloseMarginCallOrAlertModal
        isOpen={isCloseCallOpen}
        onClose={onCloseCallClose}
        account={account}
        entityId={eventId}
        isCall={isCall}
        onSuccess={onSuccess}
      />
    </>
  );
};

export default CloseCallOrAlertMenuItem;
